// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_tz-0";
export var checkoutRateBadgeLink = "_tz-1";